export const WorkflowDiagramInfoModalContents = [
  {
    name: 'How to create a new Workflow Step Function?',
    content: 'Click the plus button.'
  }
];
